import React, { useState, useEffect, useCallback } from "react";
import InputFactory from "../../../../components/InputFactory";
import { dialog } from "../../../../nq-component";
import { findObjectUseCase } from "../../../../usecases/object";
import DialogNote from "./DialogNote";

function DialogCreate({
  schema,
  coordinatorClient,
  create,
  objects,
  handleSubmit,
  handleClose,
}) {
  const [invalidFields, setInvalidFields] = useState([]);
  const [formData, setFormData] = useState({
    positionTitle2: objects?.positionTitle2 || "",
    positionTitle: objects?.positionTitle || "",
    client: objects?.client || "",
    slotVacancy: objects?.slotVacancy || "",
    qualificationStandard: objects?.qualificationStandard || "",
    jobDescription: objects?.jobDescription || "",
    location: objects?.location || "",
    deadline: objects?.deadline || "",
    id: objects?.id || undefined,
  });

  console.log("objects", objects);
  console.log("coordinatorClient", coordinatorClient);

  const [_client, _setClient] = useState(formData.client || "");
  const [_locations, _setLocations] = useState([]);

  const fetchPositionDetails = useCallback(async (positionId) => {
    if (!positionId) return;
    try {
      const query = {
        where: { id: positionId },
        include: ["locations"],
      };
      const response = await findObjectUseCase().execute(
        "position_titles",
        query
      );
      if (response?.length) {
        const data = response[0];
        setFormData((prev) => ({
          ...prev,
          positionTitle: data.positionTitle || "",
          qualificationStandard: data.qualificationStandard || "",
          jobDescription: data.jobDescription || "",
          positionTitle2: { id: data.id } || "",
          status: "Active",
        }));
      }
    } catch (error) {
      console.error("Error fetching position details:", error);
    }
  }, []);

  const getLocations = useCallback(async () => {
    if (!_client) return;
    try {
      const query = {
        where: { "clients.id": { $in: [_client.id] } },
        include: ["all", "location", "employees"],
      };
      const response = await findObjectUseCase().execute("locations", query);
      _setLocations(response.map((res) => res.name) || []);
    } catch (error) {
      console.error("Error fetching locations:", error);
    }
  }, [_client]);

  useEffect(() => {
    getLocations();
  }, [getLocations]);

  const handleChange = useCallback(
    (value, field) => {
      setFormData((prev) => ({ ...prev, [field]: value }));
      setInvalidFields((prev) => prev.filter((f) => f !== field));
      if (field === "positionTitle") fetchPositionDetails(value?.id);
      if (field === "client") _setClient(value);
    },
    [fetchPositionDetails]
  );

  const _handleSubmit = useCallback(() => {
    const updatedFormData = {
      ...formData,
      positionTitle:
        typeof formData.positionTitle === "object"
          ? formData.positionTitle.positionTitle
          : formData.positionTitle,
    };
    handleSubmit(updatedFormData);
  }, [formData, handleSubmit]);

  const validateAndSubmit = () => {
    const requiredFields = [
      "positionTitle",
      "client",
      "slotVacancy",
      "qualificationStandard",
      "jobDescription",
      "location",
      "deadline",
    ];
    console.log("f", formData);

    const missingFields = requiredFields.filter(
      (field) =>
        !formData?.[field] ||
        (typeof formData[field] === "string" && formData[field].trim() === "")
    );

    if (missingFields.length) {
      setInvalidFields(missingFields);
      dialog.fire({
        html: (
          <DialogNote missingFields={missingFields} title="Missing Fields" />
        ),
        footer: false,
      });
      return;
    }
    _handleSubmit();
  };

  return (
    <div className="p-4 rounded" style={{ maxWidth: "450px", margin: "auto" }}>
      <div
        className="d-flex align-items-center mb-3"
        style={{ color: "#d18237" }}
      >
        <div
          className="bg-light p-3 rounded-circle d-flex justify-content-center align-items-center"
          style={{ width: "50px", height: "50px" }}
        >
          <i className="bi bi-plus-circle fs-4"></i>
        </div>
        <h5 className="fw-bold ms-2">
          {create?.id ? "Edit Job Post" : "Create Job Post"}
        </h5>
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">
          Position Title<span className="text-danger fw-light ms-1">*</span>
        </label>
        <InputFactory
          type="Pointer"
          field="positionTitle"
          target="position_titles"
          onChange={handleChange}
          schemas={schema}
          placeholder="Enter position"
          required
          defaultValue={objects?.positionTitle2 || formData.positionTitle}
          className={
            invalidFields.includes("positionTitle") ? "is-invalid" : ""
          }
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">
          Client<span className="text-danger fw-light ms-1">*</span>
        </label>
        <InputFactory
          type="Pointer"
          _type="ClientPointer"
          field="client"
          target="clients"
          required
          onChange={handleChange}
          placeholder="Enter client"
          schemas={schema}
          defaultValue={formData.client || objects?.client}
          coordinatorClient={coordinatorClient}
          className={invalidFields.includes("client") ? "is-invalid" : ""}
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">
          Slot Vacancy<span className="text-danger fw-light ms-1">*</span>
        </label>
        <InputFactory
          type="Number"
          field="slotVacancy"
          onChange={handleChange}
          placeholder="Enter slot"
          defaultValue={objects.slotVacancy}
          className={invalidFields.includes("slotVacancy") ? "is-invalid" : ""}
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">
          Qualification Standard
          <span className="text-danger fw-light ms-1">*</span>
        </label>
        <InputFactory
          type="String"
          _type="Text"
          field="qualificationStandard"
          onChange={handleChange}
          placeholder="Enter qualification standard"
          defaultValue={
            formData.qualificationStandard || objects?.qualificationStandard
          }
          className={
            invalidFields.includes("qualificationStandard") ? "is-invalid" : ""
          }
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">
          Job Description<span className="text-danger fw-light ms-1">*</span>
        </label>
        <InputFactory
          type="String"
          _type="Text"
          field="jobDescription"
          onChange={handleChange}
          placeholder="Enter description"
          defaultValue={formData.jobDescription || objects?.jobDescription}
          className={
            invalidFields.includes("jobDescription") ? "is-invalid" : ""
          }
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">
          Location<span className="text-danger fw-light ms-1">*</span>
        </label>
        <InputFactory
          type="Enum"
          schemas={schema}
          options={_locations}
          field="location"
          onChange={handleChange}
          placeholder="Enter location"
          required
          defaultValue={objects?.location}
          className={invalidFields.includes("location") ? "is-invalid" : ""}
        />
      </div>

      <div className="mb-3">
        <label className="form-label fw-bold">
          Deadline<span className="text-danger fw-light ms-1">*</span>
        </label>
        <InputFactory
          type="Date"
          field="deadline"
          onChange={handleChange}
          placeholder="Enter deadline"
          defaultValue={
            objects.deadline
              ? new Date(objects.deadline).toISOString().split("T")[0]
              : ""
          }
          className={invalidFields.includes("deadline") ? "is-invalid" : ""}
          min={new Date().toISOString().split("T")[0]}
        />
      </div>

      <div className="d-flex justify-content-center">
        <button
          className="btn text-white me-2 px-4"
          style={{ backgroundColor: "#d18237" }}
          onClick={validateAndSubmit}
        >
          {create?.id ? "Update" : "Confirm"}
        </button>
        <button
          className="btn px-4"
          onClick={handleClose}
          style={{ backgroundColor: "#d0d0d0" }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
}

export default DialogCreate;
